export default "__VITE_ASSET__833804a2__"